export default __webpack_public_path__ + "static/media/shop.58c36503.jpg";